import React from 'react';
import {
  Accordion,
  Card,
  Divider,
  Flex,
  Grid,
  Loader,
  Modal,
  Stack,
  Text,
  Title
} from '@mantine/core';
import PropTypes from 'prop-types';
import Button from '../../components/elements/Button';
import FormNikActivatedBulk from '../../components/forms/FormNikActivatedBulk';
import IconFailed from '../../components/icons/IconFailed';
import IconSuccess from '../../components/icons/IconSuccess';
import styles from './styles.scoped.css';
import FormNikActivatedSingle from '../../components/forms/FormNikActivatedSingle';

function RenderModal({
  variant = '', opened = false, data = {}, handleSubmitBulk = () => {}, handledCloseModal = () => {}, actionType = '',
  minute = 0, second = 0, isTooManyRequests = false, handleSubmitSingle = () => {},
  withCloseButton = true, handleVisitStatusPage = () => {}, countDownStatus=0
}) {

  const action = {
    block: 'Diblokir',
    unblock: 'Diaktifkan',
  };

  const desc = {
    block: 'Blokir',
    unblock: 'Aktifkan',
  };

  const modalVariant = {
    nikActivatedSingle: {
      title: 'Buka Blokir NIK Pelanggan',
      size: 'lg',
      description: 'Apakah Anda yakin untuk membuka blokir NIK pelanggan?',
      customerTitle: true,
      content: (
        <FormNikActivatedSingle
          handleSubmit={handleSubmitSingle}
          isLoading={data.isLoading}
          isTooManyRequests={isTooManyRequests}
          minute={minute}
          onClose={handledCloseModal}
          second={second}
        />
      )
    },
    nikActivatedBulk: {
      title: 'Aktifkan NIK Pelanggan Sekaligus',
      size: 'lg',
      description: 'Aktifkan NIK pelanggan sekaligus dengan template CSV berdasarkan nomor NIK pelanggan.',
      content: (
        <FormNikActivatedBulk
          handledCloseModal={handledCloseModal}
          handleSubmit={handleSubmitBulk}
          isLoading={data.isLoading}
          isTooManyRequests={isTooManyRequests}
          minute={minute}
          second={second}
        />
      )
    },
    reason: {
      title: `Daftar Pelanggan Berhasil ${action[actionType]} Sebagian`,
      size: 'xl',
      content: (
        <Flex direction="column" gap="md">
          <Card p="sm" radius="md" sx={{ padding: '10px' }} withBorder>
            <Flex align="center" direction="row" gap="sm" pl={10}>
              <IconSuccess type={'small'} />
              <Text>
                {data?.data?.successTotal} Pelanggan Berhasil {action[actionType]}
              </Text>
            </Flex>
          </Card>
          <Accordion radius="md" variant="contained">
            <Accordion.Item value="print">
              <Accordion.Control icon={<IconFailed type={'small'} />} py=".2rem">
                {data?.data?.failedTotal} Pelanggan Gagal {action[actionType]}
              </Accordion.Control>
              <Accordion.Panel mx="sm" sx={{ borderTop: '1px solid #D9DEE4' }}>
                {data?.data?.failedDetails?.map((item, index) => (
                  <Grid grow justify="space-between" key={index} mt={10}>
                    <Grid.Col span={4}>
                      <Text fz={14}>{item.nationalityId}</Text>
                    </Grid.Col>
                    <Grid.Col span={4} ta="right">
                      <Text c="#CF212A" fz={14}>{item.error}</Text>
                    </Grid.Col>
                  </Grid  >
                ))}
              </Accordion.Panel>
            </Accordion.Item>
          </Accordion>
          <Button fullWidth onClick={handledCloseModal}>
            Tutup
          </Button>
        </Flex>
      )
    },
    processing_bulk: {
      customerTitle: true,
      title: null,
      content: (
        <Stack>
          <Flex align="center" gap="md">
            {countDownStatus < 30 &&<Loader/>}
            <Title order={4}>Sedang Memproses Permintaan {desc[actionType]} Daftar Pelanggan</Title>
          </Flex>
          <Text c="#344054">Anda dapat klik tombol di bawah untuk mengakses halaman
             status {actionType  === 'block'? 'blokir' : 'aktivasi'} data dan Anda dapat mengakses menu lain selama proses berlangsung.</Text>
          <Button fullWidth
            onClick={handleVisitStatusPage}>Lihat Status Proses {desc[actionType]} Data</Button>
        </Stack>
      )
    }
  };

  return (
    <Modal centered onClose={handledCloseModal} opened={opened}
      size={modalVariant[variant]?.size || 'lg'}
      styles={{
        title: {
          fontWeight: 600,
          fontSize: 30
        }
      }}
      title={modalVariant[variant]?.customerTitle ? (
        modalVariant[variant]?.title
      ) : null} withCloseButton={withCloseButton}>
      <div className={styles.container}>
        {!modalVariant[variant]?.customerTitle && (
          <>
            <Text align="center" component="h3" fw={'normal'} fz={24} my={0}>
              {modalVariant[variant]?.title}
            </Text>
            <Divider
              bg={'#5E811E'}
              my={16}
              size="xl"
              styles={{
                root: {
                  width: '5rem',
                  borderColor: '#5E811E',
                  margin: 'auto',
                  borderRadius: '5px',
                }
              }}
            />
          </>
        )}
        {modalVariant[variant]?.description &&<Text align={
          modalVariant[variant]?.customerTitle ? 'left' : 'center'
        } c={'#52575C'} fw={400} fz={16} mb={24}>
          {modalVariant[variant]?.description}
        </Text>}
        <>{modalVariant[variant]?.content}</>
      </div>
    </Modal>
  );
}

export default RenderModal;

RenderModal.propTypes = {
  actionType: PropTypes.oneOf(['block', 'unblock']),
  countDownStatus: PropTypes.number,
  data: PropTypes.object,
  dataBusinessType: PropTypes.object,
  editName: PropTypes.string,
  errorEditBusinessType: PropTypes.string,
  handledCloseModal: PropTypes.func,
  handledNikActivated: PropTypes.func,
  handleReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSubmitBulk: PropTypes.func,
  handleSubmitSingle: PropTypes.func,
  handleVisitStatusPage: PropTypes.func,
  isChecked: PropTypes.bool,
  isTooManyRequests: PropTypes.bool,
  minute: PropTypes.string,
  opened: PropTypes.bool,
  second: PropTypes.string,
  setEditName: PropTypes.string,
  updateNikStatusBulk: PropTypes.object,
  variant: PropTypes.oneOf(['reason', 'nikActivatedBulk', 'nikActivatedSingle']),
  withCloseButton: PropTypes.bool
};
